import { Box, Checkbox, Divider, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldLabel from "../common/TextFieldLabel";
import { CustomSelectBox } from "assets/styles/globalStyledComponent";
import { MenuProps } from "app/utils/helper";
import ClassDropDown from "app/modules/fee-management/fee-structure/ClassDropdown";
import { useClassData } from "app/hooks/globallyApplicable/useClassData";
import { useFormik } from "formik";

const buildClassListFromData = (classListData, postClassList = []) => {
  const selected = Array.isArray(postClassList) ? postClassList : [];
  return (classListData ?? []).map((classItem) => {
    const updatedSections = (classItem?.sections ?? []).map((section) => {
      const isChecked = selected.some(
        (postClass) =>
          postClass?.classDocId === classItem?.classDocId &&
          postClass?.section === section,
      );
      return { section, checked: isChecked };
    });
    return {
      classDocId: classItem?.classDocId,
      className: classItem?.className_stream,
      queryClassName: classItem?.className,
      sections: updatedSections,
      checked: updatedSections.every((s) => s.checked),
    };
  });
};

const setAllClassesChecked = (list, checked) =>
  list.map((c) => ({
    ...c,
    checked,
    sections: (c.sections ?? []).map((s) => ({ ...s, checked })),
  }));

const ByClassFilter = ({ prevClassList, setSelectedClasses }) => {
  const [classList, setClassList] = useState([]);

  const formik = useFormik({
    initialValues: {
      postClassList: Array.isArray(prevClassList) ? prevClassList : [],
    },
    onSubmit: (values) => {},
  });

  const { classList: classListData, error } = useClassData();

  useEffect(() => {
    if (classListData?.length > 0) {
      setClassList(buildClassListFromData(classListData, prevClassList));
    }
  }, [classListData, prevClassList]);

  // Handle class data error
  useEffect(() => {
    if (error) {
      console.error("Failed to fetch class data:", error);
    }
  }, [error]);

  useEffect(() => {
    setSelectedClasses(formik.values.postClassList);
  }, [formik.values.postClassList, setSelectedClasses]);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <TextFieldLabel title={"Class-Stream-Sec"} />
          <CustomSelectBox
            size="small"
            fullWidth
            multiple
            displayEmpty
            MenuProps={MenuProps}
            value={formik.values.postClassList ?? []}
            error={
              formik.touched.postClassList &&
              Boolean(formik.errors.postClassList)
            }
            renderValue={(selected) => {
              if (Array.isArray(selected) && selected.length > 0) {
                return (
                  <span>
                    {(selected ?? []).map((cls) => cls?.display).join(", ")}
                  </span>
                );
              }
              return <Typography sx={{ opacity: 0.8 }}>Select</Typography>;
            }}
          >
            <Box sx={{ px: 1, py: 0.5 }}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <Checkbox
                    color="secondary"
                    checked={
                      Array.isArray(classListData) &&
                      classListData.length > 0 &&
                      (formik.values?.postClassList?.length ?? 0) > 0 &&
                      (formik.values?.postClassList?.length ?? 0) ===
                        (classListData ?? []).reduce(
                          (sum, c) => sum + (c?.sections?.length ?? 0),
                          0,
                        )
                    }
                    onChange={(e) => {
                      const shouldSelectAll = e.target.checked;
                      if (!shouldSelectAll) {
                        formik.setValues((prev) => ({
                          ...prev,
                          postClassList: [],
                        }));
                        setClassList((prev) => setAllClassesChecked(prev, false));
                        return;
                      }
                      const all = [];
                      (classListData ?? []).forEach((c) => {
                        (c?.sections ?? []).forEach((section) => {
                          all.push({
                            classDocId: c?.classDocId,
                            section,
                            display: `${c?.className_stream}-${section}`,
                            queryClass: c?.className,
                          });
                        });
                      });
                      formik.setValues((prev) => ({
                        ...prev,
                        postClassList: all,
                      }));
                      setClassList((prev) => setAllClassesChecked(prev, true));
                    }}
                  />
                  <Typography sx={{ fontWeight: 600 }}>All</Typography>
                </Stack>
                <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
                  {formik.values?.postClassList?.length ?? 0} selected
                </Typography>
              </Stack>
            </Box>
            <Divider sx={{ background: "#B6C8D6" }} />
            {classList?.map((item, ind) => (
              <ClassDropDown
                item={item}
                index={ind}
                formikSetState={formik.setValues}
                formikState={formik.values}
                key={item?.classDocId ?? ind}
              />
            ))}
          </CustomSelectBox>
          {formik.touched.postClassList &&
            Boolean(formik.errors.postClassList) && (
              <Typography color="error">
                {formik.errors.postClassList}
              </Typography>
            )}
        </Grid>
      </Grid>
    </>
  );
};

export default ByClassFilter;
